<!-- Staff Activation Dialog - M3 Design (design.pen Node: ummu1) -->
<!-- PHASE22: Use warning color for deactivation (not danger/red - red is for delete only) -->
<div class="confirm-dialog" [class.confirm-dialog--warning]="accountData?.contractInfo?.contractStatus === 'OPEN'">
  <!-- Header -->
  <div class="confirm-dialog__header">
    <div class="confirm-dialog__title">
      <div class="confirm-dialog__icon-wrapper" [class.confirm-dialog__icon-wrapper--warning]="accountData?.contractInfo?.contractStatus === 'OPEN'" [class.confirm-dialog__icon-wrapper--primary]="accountData?.contractInfo?.contractStatus === 'CLOSE'">
        <mat-icon>{{ accountData?.contractInfo?.contractStatus === 'OPEN' ? 'person_off' : 'person' }}</mat-icon>
      </div>
      @if (accountData?.contractInfo?.contractStatus === 'OPEN') {
        <span i18n="@@adminSection.staffActivation.title.deactivate">アカウント停止</span>
      } @else {
        <span i18n="@@adminSection.staffActivation.title.reactivate">アカウント有効化</span>
      }
    </div>
    <button mat-icon-button class="confirm-dialog__close" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="confirm-dialog__content">
    @if (isLoading()) {
      <!-- Skeleton Loading -->
      <div class="skeleton-form">
        <div class="skeleton-user-info">
          <div class="skeleton skeleton--name"></div>
          <div class="skeleton skeleton--meta"></div>
        </div>
        <div class="skeleton skeleton--warning-box"></div>
      </div>
    } @else {
      <!-- Primary Account Warning -->
      @if (primaryAccount) {
        <p class="confirm-dialog__message" i18n="@@adminSection.staffActivation.message.primaryAccountRestriction">
          本アカウントは停止することが出来ません。プライマリースタッフアカウントの停止及び変更につきましてはサポート窓口へご連絡ください。
        </p>
      }
      <!-- Own Account Warning -->
      @else if (ownAccount) {
        <p class="confirm-dialog__message" i18n="@@adminSection.staffActivation.message.ownAccountRestriction">
          本スタッフアカウントはご自身のアカウントです。スタッフアカウントの停止及び変更につきましてはセクションのスタッフ管理者までご連絡ください。
        </p>
      }
      <!-- Normal Deactivation -->
      @else if (accountData?.contractInfo?.contractStatus === 'OPEN') {
        <div class="confirm-dialog__user-info">
          <div class="confirm-dialog__user-name">{{ accountData?.user?.lastName }} {{ accountData?.user?.firstName }}</div>
          <div class="confirm-dialog__user-meta" i18n="@@adminSection.staffActivation.label.staff">スタッフ</div>
        </div>
        <div class="confirm-dialog__warning-box">
          <mat-icon>warning</mat-icon>
          <p i18n="@@adminSection.staffActivation.message.deactivateWarning">
            このアカウントを停止すると、本セクションでの計測や情報の閲覧が停止されます。後から再開することも可能です。
          </p>
        </div>
      }
      <!-- Reactivation -->
      @else if (accountData?.contractInfo?.contractStatus === 'CLOSE') {
        <div class="confirm-dialog__user-info">
          <div class="confirm-dialog__user-name">{{ accountData?.user?.lastName }} {{ accountData?.user?.firstName }}</div>
          <div class="confirm-dialog__user-meta" i18n="@@adminSection.staffActivation.label.staffSuspended">スタッフ（停止中）</div>
        </div>
        <p class="confirm-dialog__message" i18n="@@adminSection.staffActivation.message.reactivateInfo">
          このスタッフアカウントを有効化すると、再びシステムにログインできるようになります。
        </p>
      }
    }
  </div>

  <!-- Footer -->
  <div class="confirm-dialog__footer">
    <button mat-stroked-button (click)="onNoClick()">
      <span i18n="@@adminSection.staffActivation.button.cancel">閉じる</span>
    </button>

    @if (primaryAccount || ownAccount) {
      <!-- Disabled state for restricted accounts -->
      <button mat-flat-button color="primary" disabled>
        <mat-icon>person_off</mat-icon>
        <span i18n="@@adminSection.staffActivation.button.confirmDeactivate">停止する</span>
      </button>
    } @else if (accountData?.contractInfo?.contractStatus === 'OPEN') {
      <button mat-flat-button color="accent" [disabled]="isSending()" (click)="deactivate()">
        @if (isSending()) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <mat-icon>person_off</mat-icon>
        }
        <span i18n="@@adminSection.staffActivation.button.deactivate">停止する</span>
      </button>
    } @else if (accountData?.contractInfo?.contractStatus === 'CLOSE') {
      <button mat-flat-button color="primary" [disabled]="isSending()" (click)="reactivate()">
        @if (isSending()) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <mat-icon>person</mat-icon>
        }
        <span i18n="@@adminSection.staffActivation.button.reactivate">有効化する</span>
      </button>
    }
  </div>
</div>
